import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import TeaserPhoto from 'components/TeaserPhoto';
import { Button } from 'components/Button';
import './index.sass';
import { Skeleton } from '@mui/material';
import Model from '../../../../model';

const { block, el } = bem('fixed-specialist-teaser');
export const FixedSpecialistTeaser = ({ specialist }) => {
    const { name, length } = specialist.data;
    const { workingWithPairs, photo } = specialist;
    const { price } = specialist.data.servicesSet[0];
    const { openSpecialistOrderForm } = Model.modal;
    const onClick = (e) => {
        e.preventDefault();
        openSpecialistOrderForm(specialist.id);
    }
    return (
        <div className={block()} >
            <div className={el('top-block')}>
                <div className={el('photo')}>
                    <TeaserPhoto src={photo} alt={`Фото специалиста ${name}`} />
                </div>
            </div>
            <div className={el('price-block')}>
                <div className={el('price-label')}>
                    <Text>Стоимость</Text>
                </div>
                <div className={el('prices-list')}>
                    <div className={el('price-single')}>
                        <Icon name={'user'} />
                        <Text className={el('price')}>{`${price} ₽`}</Text>
                        <Text className={el('duration')}>{` ${length} мин`}</Text>
                    </div>
                    <div className={el('price-pair')}>
                        <Icon name={'users'} />
                        <Text className={el('price')}>{workingWithPairs ? `${price} ₽` : '-'}</Text>
                        { workingWithPairs && <Text className={el('duration')}>{` ${ length } мин`}</Text> }
                    </div>
                </div>
            </div>
            <div className={el('button')}>
                <Button name={'arrow-right'} mod={'transparent-gold'} onClick={onClick}><Text>Записаться к специалисту</Text></Button>
            </div>
        </div>
    )
}

export const FixedSpecialistTeaserSkeleton = () => {
    return (
        <div className={block()} >
            <div className={el('top-block')}>
                <div className={el('photo')}>
                    <Skeleton variant={'rounded'} style={{borderRadius: '10px'}}><TeaserPhoto/></Skeleton>
                </div>
            </div>
            <div className={el('price-block')}>
                <div className={el('price-label')}>
                    <Text><Skeleton width={100}/></Text>
                </div>
                <div className={el('prices-list')}>
                    <div className={el('price-single')}>
                        <Text className={el('price')}><Skeleton width={100}/></Text>
                    </div>
                    <div className={el('price-pair')}>
                        <Text className={el('price')}><Skeleton width={100}/></Text>
                    </div>
                </div>
            </div>
            <div className={el('button')}>
                <Skeleton variant={'rounded'} height={42}/>
            </div>
        </div>
    )
}
